exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".direction-input[data-v-4716d890]{direction:ltr}.direction-label[data-v-4716d890]{text-align:left}.fontStyle[data-v-4716d890]{font-size:12px}.errorStyle[data-v-4716d890]{color:red}.errorStyle[data-v-4716d890],.fontWeight[data-v-4716d890]{font-weight:bolder}", ""]);

// exports
